import { createAsyncThunk } from '@reduxjs/toolkit';

import { DOCUMENT_TYPES } from '@backrs_ui/grow-ui/src/models/models';
import { RootState } from '@backrs_ui/grow-ui/src/redux/store';

import { userDocumentsApi } from '../user.documents.api';

export const checkUserDocuments = createAsyncThunk(
  'user/checkUserDocuments',
  async (_, { getState, dispatch, rejectWithValue }) => {
    const state = getState() as RootState;
    const userId = state.user.user?.id;

    if (!userId) {
      return rejectWithValue('No user ID found');
    }

    try {
      // Force a fresh API call by using refetch with forceRefetch option whenever thunk is called
      const result = await dispatch(
        userDocumentsApi.endpoints.checkUserDocuments.initiate(
          {
            userId,
            documents: Object.values(DOCUMENT_TYPES),
          },
          { forceRefetch: true },
        ),
      ).unwrap();

      return result;
    } catch (error) {
      return rejectWithValue('Failed to check user resume: ' + error);
    }
  },
);
